import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs"; 
import { Link } from "react-router-dom";
import * as apiUrl from "../../apiUrl";
import SwiperCore, { FreeMode, Navigation, Thumbs, Autoplay } from "swiper";

SwiperCore.use([FreeMode, Navigation, Thumbs, Autoplay]);

function HomeCommunity() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [HomeCommunities, setHomeCommunities] = useState({});

  useEffect(() => {
    const fetchHomeCommunities = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/home/our-communities-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setHomeCommunities(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchHomeCommunities();
  }, []);

  // Ensure to parse images only if they are defined
  const images = HomeCommunities.slide_images
    ? JSON.parse(HomeCommunities.slide_images)
    : [];
  const thumbImages = HomeCommunities.slide_thumb_images
    ? JSON.parse(HomeCommunities.slide_thumb_images)
    : [];

  return ( 
      <div className="home-community-sec">
        <Container fluid>
          <Row>
            <Col md={12}>
              <div className="home-community-head" data-aos="fade-right">
                <h2 className="common-head goldenColor" data-aos="fade-right">
                  {HomeCommunities.section_title}
                </h2>
                <p className="common-para" data-aos="fade-right">
                  {HomeCommunities.description}
                </p>
                {/* <Link
                  to={HomeCommunities.button_link}
                  className="marquis-grey-button"
                >
                  {HomeCommunities.button_text}
                </Link> */}
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="home-community-container">
          <Row>
            <Col md={12}>
              <div className="home-community-swiper">
                <Swiper
                  loop={false}
                  spaceBetween={0}
                  autoplay={true}
                  speed={1000}
                  thumbs={{
                    swiper:
                      thumbsSwiper && !thumbsSwiper.destroyed
                        ? thumbsSwiper
                        : null,
                  }}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="mySwiper2"
                >
                  {images.map((image, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={`${apiUrl.apiUrl}/${image}`}
                        className="img-fluid"
                        alt={`Property development in Dubai`}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <Swiper
                  onSwiper={setThumbsSwiper}
                  loop={false}
                  autoplay={true}
                  speed={1000}
                  spaceBetween={20}
                  slidesPerView={7}
                  freeMode={true}
                  watchSlidesProgress={true}
                  modules={[FreeMode, Navigation, Thumbs]}
                  breakpoints={{
                    240: { slidesPerView: 4, spaceBetween: 10 },
                    320: { slidesPerView: 4, spaceBetween: 10 },
                    420: { slidesPerView: 4, spaceBetween: 10 },
                    768: { slidesPerView: 4, spaceBetween: 10 },
                    1024: { slidesPerView: 6 },
                    1280: { slidesPerView: 7 },
                  }}
                  className="mySwiper"
                >
                  {thumbImages.map((thumbImage, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={`${apiUrl.apiUrl}/${thumbImage}`}
                        className="img-fluid"
                        alt={`Property development in Dubai`}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
      </div> 
  );
}

export default HomeCommunity;
